import { render, staticRenderFns } from "./ScaffoldHeader.vue?vue&type=template&id=f3bf04c8"
import script from "./ScaffoldHeader.vue?vue&type=script&lang=ts"
export * from "./ScaffoldHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3bf04c8')) {
      api.createRecord('f3bf04c8', component.options)
    } else {
      api.reload('f3bf04c8', component.options)
    }
    module.hot.accept("./ScaffoldHeader.vue?vue&type=template&id=f3bf04c8", function () {
      api.rerender('f3bf04c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scaffold/ScaffoldHeader.vue"
export default component.exports